<template>
  <div class="clientsAdd">
    <div class="pageContent">
      <heading type="h1">Edit User</heading>
      <spinner v-if="loading" />
      <user-form :user="user" :submit="save" @loading="onLoadingStatus" />
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'
import ButtonCta from '@/components/Button/button'
import Spinner from '@/components/SpinnerIcon/spinner'
import UserForm from '@/components/UserForm/user-form'
import {userMixin} from '@/mixins/userMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import {pageMixin} from '@/mixins/pageMixin'

export default {
  name: 'UsersEdit',
  mixins: [userMixin, notificationMixin, pageMixin],
  components: {
    Heading,
    ButtonCta,
    Spinner,
    UserForm
  },
  data: () => ({
    loading: false,
    clientNew: {
      currency: 'gbp'
    }
  }),
  methods: {
    add () {
      this.loading = true
    },
    save () {
      this.loading = true
      console.log('this.user', this.user)
      this.updateUser(this.user).then(() => {
        this.addNotification('success', `'${this.user.name} user' Successfully updated.`)
        this.loading = false
      }, error => {
        this.loading = false
        this.addNotification('danger', error)
      })
    }
  },
  created () {
    this.loading = true
    this.getUser(this.$route.params.id).then(() => {
      console.log('Single user loaded', this.user)
      this.loading = false
    })
  }
}
</script>

<style lang="scss">
    .usersEdit {
    }
</style>



// WEBPACK FOOTER //
// src/pages/user/users-edit.vue